<template>
  <div class="renewal-confirmation">
    <Header :noNav="false"></Header>
    <b-container>
      <b-row>
        <div class="renewal-confirmation__row">
          <span class="renewal-confirmation__icon"/>
          <h1>
            Renovação concluída
          </h1>
          <p>
            Você irá receber seu bilhete de seguro por e-mail e uma cópia dessas informações.
           <b>Caso não receba o e-mail verifique a sua caixa de spam.</b>
          </p>
        </div>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import Header from '../../Header/Header'

export default {
  name: 'RenewalConfirmation',
  components: { Header }
}
</script>
<style lang="scss" scoped>
$breakpoint-mobile: 480px;

.renewal-confirmation {
  background-color: #f5f7fa;
  min-height: 100%;

  &__row {
    text-align: center;
    width: 100%;
    margin-top: 48px;
    padding: 0 8px;

    h1 {
        font: bold 32px Oscine;
        color: #444444;
        margin: 12px 0 24px 0;
        @media only screen and (max-width: $breakpoint-mobile) {
          font-size: 24px;
        }
    }
    p {
      font-family: Rubik;
      color: #595959;
      font-size: 16px;
      margin: 0 auto !important;
      max-width: 568px;
    }
  }
  &__icon {
    width: 48px;
    height: 48px;
    border-radius: 100%;
    display: inline-block;
    background: url(~@/assets/svg/icone-sucesso.svg) no-repeat center;
  }
  @media only screen and (max-width: $breakpoint-mobile) {
  }
}

</style>
